import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../../FireInTheHole2";

export class DropInPresentation implements SimplePresentation {
    name:string = "DropInPresentation";
    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() =>{
            tl.progress(1);
        }));
        let padding:number = FireInTheHole2.gameFlowController.calculatePaddingDuration(FireInTheHole2.reelArea.DROP_IN_REEL_DELAY*5)
        padding = (padding>0?padding:0);
        tl.add(FireInTheHole2.reelArea.dropIn(padding));
        tl.add(()=>{
            FireInTheHole2.reelFrame.updateWays(FireInTheHole2.model.totalWays);
            FireInTheHole2.reelAnticipation.fadeOutAnticipationSound();
        });
        tl.add(() => controller.finish());
    }
}